// extracted by mini-css-extract-plugin
module.exports = {"button":"soundButton-module--button--swH-i","button__show":"soundButton-module--button__show--3Kmjq","svg":"soundButton-module--svg--5_HxB"};